import store from '../store/index';

import IntegrationQueries from '../queries/integration.queries';
import ApiService from './ApiService';
import UtilsService from './UtilsService';

async function getAllIntegrations() {
  const retailerId = store.state.auth.currentUser &&
    store.state.auth.currentUser.retailer &&
    store.state.auth.currentUser.retailer.objectId;
  if (retailerId) {
    const query = IntegrationQueries.getAll(store.state.auth.currentUser.retailer.objectId);
    return ApiService.get(UtilsService.buildFullPath(query)).then((res) => res.results);
  }
  return [];
}

async function getAllIntegrationsByPlatform(platform: string) {
  if (!store.state.auth.currentUser) { return null; }
  const query = IntegrationQueries.getAllByPlatform(store.state.auth.currentUser.retailer.objectId, platform);
  return ApiService.get(UtilsService.buildFullPath(query)).then(
    (res) => res.results && res.results.length && res.results[0],
  );
}

function getPhoneNumber() {
  const wabIntegration: any = store.state.integration.integrations.find((int: any) => (
    int.status === 'READY' &&
    (['wab-smooch', 'wab', 'wab-dialog',
      'wab-twilio', 'wab-dialog-api', 'wab-omnichat'].includes(int.platform))
  ));

  if (wabIntegration) {
    const profile = wabIntegration.wabRequestProfile;
    return {
      countryCode: profile.countryCode || profile.wabCountryCode || '55',
      areaCode: profile.phoneAreaCode || profile.wabAreaCode,
      number: profile.phoneNumber || profile.wabNumber,
    };
  } else {
    throw new Error('Número de telefone não configurado');
  }
}

const IntegrationService = {
  getAllIntegrations,
  getAllIntegrationsByPlatform,
  getPhoneNumber,
};

export default IntegrationService;
